import React, { Component } from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { Helmet } from 'react-helmet';
import 'whatwg-fetch';
import ExternalButton from 'components/ExternalButton';
import PageTitleBar from 'components/PageTitleBar';
import VideoList from 'components/VideoList';
import VideoPlayer from 'components/VideoPlayer';
import { YOUTUBE_CHANNEL_URL } from 'utils/constants';
import VideosIcon from 'resources/FeatureIcons/Button-Videos.svg';
import './VideoFeed.css';

class VideoFeed extends Component {
  constructor(props) {
    super(props);

    this.state = {
      videos: null,
      selectedVideoId: null,
      loading: true
    };

    this.selectVideo = this.selectVideo.bind(this);
  }

  componentDidMount() {
    this.selectDefaultVideo(this.props);
  }

  componentDidUpdate() {
    this.selectDefaultVideo();
  }

  selectDefaultVideo() {
    const {
      youtubeVideosData: { getWindCreekYoutubeVideos: videos }
    } = this.props;

    if (
      videos &&
      videos.items &&
      videos.items.length &&
      !this.state.selectedVideoId
    ) {
      this.setState({
        selectedVideoId: videos.items[0].videoId
      });
    }
  }

  selectVideo(video) {
    if (video && video.videoId) {
      this.setState({ selectedVideoId: video.videoId });
    }
  }

  renderContent() {
    const {
      youtubeVideosData: { loading, getWindCreekYoutubeVideos: videos, error }
    } = this.props;
    const { selectedVideoId } = this.state;

    if (loading) {
      return null;
    } else if (error) {
      return (
        <div className="video-feed-error">
          <div className="alert alert-danger">
            An error occurred while fetching the videos. Please try again later.
          </div>
        </div>
      );
    } else {
      const selectedVideo =
        videos.items &&
        videos.items.find(video => video.videoId === selectedVideoId);

      return videos && videos.items.length > 0 ? (
        <div className="video-feed">
          <div className="left-column">
            {selectedVideo && <VideoPlayer video={selectedVideo} />}
          </div>
          <div className="right-column">
            <VideoList
              videos={videos.items}
              onVideoClick={this.selectVideo}
              nowPlayingVideo={selectedVideo}
            />
          </div>
        </div>
      ) : (
        <div className="notice">
          Please visit our channel on YouTube to see the latest news and
          content!
          <ExternalButton to={YOUTUBE_CHANNEL_URL} buttonStyle="success">
            Wind Creek Hospitality
          </ExternalButton>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="video-page">
        <Helmet>
          <title>Videos</title>
        </Helmet>
        <PageTitleBar title="Videos" icon={VideosIcon} />
        {this.renderContent()}
      </div>
    );
  }
}

export const QUERY_GET_YOUTUBE_VIDEOS = gql`
  query {
    getWindCreekYoutubeVideos {
      items {
        videoId
        publishedAt
        title
        description
      }
    }
  }
`;

export default graphql(QUERY_GET_YOUTUBE_VIDEOS, {
  name: 'youtubeVideosData'
})(VideoFeed);
